export default __webpack_public_path__ + "static/media/devices-guide.b6f8ad3d.png";